import { ContentSuggestionItem } from './content-suggestion-item'
export default ContentSuggestionItem
